<template>
    <Field v-bind="$props">
        <AntInputNumber
            :id="name"
            v-model="innerValue"
            class="w-full"
            :class="elementClasses"
            v-bind="$attrs"
            @blur="$emit('blur')"
        />
    </Field>
</template>

<script>
import Field from '@/components/field/Field.vue';
import { InputNumber } from 'ant-design-vue';
import fieldMixin from '@/mixins/fieldMixin';
export default {
    components: {
        AntInputNumber: InputNumber,
        Field,
    },
    mixins: [fieldMixin],
    props: {
        value: {
            type: null,
            required: true,
        },
    },
};
</script>

<style></style>
